<div class="iq-pricing text-center">
  <app-parallax-hero-style1 bgImage="./assets/images/bg/08.jpg" classNames="price-title iq-parallax iq-over-blue-80">
    <ng-content select="[cardHeader]"></ng-content>
  </app-parallax-hero-style1>
  <ng-content select="[cardList]"></ng-content>
  <div class="price-footer">
    <ng-content select="[cardFooter]"></ng-content>
  </div>
</div>
